import { render } from "./06-GeolocationPermissionsDenied.vue?vue&type=template&id=56a0c8e2"
import script from "./06-GeolocationPermissionsDenied.vue?vue&type=script&lang=js"
export * from "./06-GeolocationPermissionsDenied.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__